export const BULK_ITEM_CATEGORY_OTHER_ID = 8;
